import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAccessToken } from '../store/actions/auth';
import API_BASE_URL from '../config/baseUrl';

const MATKA_ID = 3;

const fetchMatkaBetLock = async function() {
  try {
    const token = getAccessToken();
    if (!token) {
      return { success: false, error: 'No access token found' };
    }

    const response = await axios.get(
      API_BASE_URL + '/superadmin/matka-betting-lkunlk',
      { headers: { Authorization: 'Bearer ' + token } }
    );

    const data = response.data;
    if (data.status === false) {
      return { success: false, error: data.message || 'Failed to fetch matka bet lock' };
    }

    const betLock = Boolean(
      data.data?.betLock ?? data.data?.matkaBetLock ?? data.betLock
    );
    return { success: true, betLock: betLock };
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to fetch matka bet lock';
    return { success: false, error: errorMessage };
  }
};

const updateMatkaBetLock = async function(isLock) {
  try {
    const token = getAccessToken();
    if (!token) {
      return { success: false, error: 'No access token found' };
    }

    const response = await axios.post(
      API_BASE_URL + '/superadmin/matka-betting-lkunlk',
      { matkaId: MATKA_ID, betLock: isLock },
      { headers: { Authorization: 'Bearer ' + token } }
    );

    const data = response.data;
    if (data.status === false) {
      return { success: false, error: data.message || 'Failed to update matka bet lock' };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to update matka bet lock';
    return { success: false, error: errorMessage };
  }
};

const SuperAdminMatkaBetLockPage = () => {
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [betLock, setBetLock] = useState(false);

  useEffect(function() {
    const load = async function() {
      setLoading(true);
      setError(null);

      const result = await fetchMatkaBetLock();
      if (result.success) {
        setBetLock(result.betLock);
      } else {
        setError(result.error);
      }

      setLoading(false);
    };

    load();
  }, []);

  const handleToggle = async function() {
    if (updating) return;
    setUpdating(true);
    setError(null);

    const nextValue = !betLock;
    const result = await updateMatkaBetLock(nextValue);
    if (result.success) {
      setBetLock(nextValue);
    } else {
      setError(result.error || 'Failed to update matka bet lock');
    }

    setUpdating(false);
  };

  return (
    <div className="w-full">
      <div className="flex justify-center">
        <div className="w-full max-w-4xl px-2">
          <div className="bg-white rounded shadow border border-gray-200">
            <div className="bg-gray-600 px-5 py-3">
              <span className="text-2xl text-white font-normal capitalize">
                Super Admin Matka Lock
              </span>
            </div>

            <div className="p-6">
              {loading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                </div>
              ) : error ? (
                <div className="p-4 text-red-500 text-center">{error}</div>
              ) : (
                <div className="flex items-center justify-between border border-gray-300 p-4">
                  <div className="text-sm font-medium">Matka Bet Lock</div>
                  <button
                    onClick={handleToggle}
                    disabled={updating}
                    className={
                      (betLock ? 'bg-red-600' : 'bg-green-600') +
                      ' text-white px-4 py-1 disabled:opacity-50'
                    }
                    style={{ borderRadius: 0 }}
                  >
                    {betLock ? 'Locked' : 'Unlocked'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminMatkaBetLockPage;
